import { render, staticRenderFns } from "./explain-realtime-queries.component.vue?vue&type=template&id=1a0c4214&scoped=true"
import script from "./explain-realtime-queries.component.vue?vue&type=script&lang=ts"
export * from "./explain-realtime-queries.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-realtime-queries.component.vue?vue&type=style&index=0&id=1a0c4214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c4214",
  null
  
)

export default component.exports